import React, { useMemo } from "react";
import Select from "react-select";

const ClearIndicator = (props) => {
  const {
    children = <i className="fas fa-times" />,
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;

  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={getStyles("clearIndicator", props)}
    >
      <div style={{ padding: "0px 5px" }}>{children}</div>
    </div>
  );
};

const ClearIndicatorStyles = (base, state) => ({
  ...base,
  cursor: "pointer",
  color: state.isFocused ? "blue" : "black",
});

export default function CustomSelect({
  options,
  onChange,
  defaultsValues,
  ...props
}) {
  // Usar defaultValue o defaultValues de los props si defaultsValues no está definido
  const actualDefaultValue =
    defaultsValues || props.defaultValue || props.defaultValues;
  const validOptions = Array.isArray(options) ? options : [];

  const mappedOptions = useMemo(() => validOptions.map((option) => ({
    value: option.slug ? option.slug : option.uuid,
    label: option.nombre,
  })), [validOptions]);

  // Buscar el valor predeterminado en el arreglo de opciones
  let defaultValue = null;
  defaultValue = mappedOptions.find(
    (option) => option.value === actualDefaultValue,
  );

  // Si defaultValue no se encuentra, buscar comparacion con el nombre del mappedOptions
  if (defaultValue === null || defaultValue === undefined) {
    defaultValue = mappedOptions.find(
      (option) => option.label === actualDefaultValue,
    );
  }

  return (
    <Select
      id={props.id ? props.id : ""}
      components={{ ClearIndicator }}
      styles={{ clearIndicator: ClearIndicatorStyles }}
      defaultValue={defaultValue}
      value={defaultValue}
      onChange={onChange}
      options={mappedOptions}
      isMulti={props.isMulti}
      closeMenuOnSelect={!props.isMulti}
      placeholder={
        props.placeholder ? props.placeholder : "Seleccione opciones..."
      }
      {...props}
    />
  );
}

export function CustomSelectParqueaderos({
  options,
  onChange,
  defaultsValues,
  ...props
}) {
  const validOptions = Array.isArray(options) ? options : [];

  const mappedOptions = useMemo(() => validOptions.map((option) => ({
    value: option.slug ? option.slug : option.uuid,
    label: option.nombre,
    isDisabled: option.no_disponible,
  })), [validOptions]);

  // Buscar el valor predeterminado en el arreglo de opciones
  let defaultValue = null;
  defaultValue = mappedOptions.find(
    (option) => option.value === defaultsValues,
  );

  // Si defaultValue no se encuentra, buscar comparación con el nombre del mappedOptions
  if (defaultValue === null || defaultValue === undefined) {
    defaultValue = mappedOptions.find(
      (option) => option.label === defaultsValues,
    );
  }

  return (
    <Select
      id={props.id ? props.id : ""}
      components={{ ClearIndicator }}
      styles={{ clearIndicator: ClearIndicatorStyles }}
      defaultValue={defaultValue}
      value={defaultValue}
      onChange={onChange}
      options={mappedOptions}
      isMulti={props.isMulti}
      closeMenuOnSelect={!props.isMulti}
      placeholder={
        props.placeholder ? props.placeholder : "Seleccione opciones..."
      }
      {...props}
    />
  );
}
